import React from "react";
import ReactDOM from "react-dom";
import { useSelector, useDispatch } from "react-redux";
import { createAccount, updateAccount } from "../actions/account";
import { useNavigate } from "react-router-dom";
import { isNotNull } from "../common/utils";
import i18n from "../i18n";
import settingIcon from "./../assets/img/seting-icon.svg";
import lightIcon from "./../assets/img/Light.png";
import logo from "./../assets/img/Logo.png";
import laIcon from "./../assets/img/myanmar.png";
import enIcon from "./../assets/img/usk.png";
import { useTranslation } from "react-i18next";

const Header = ({ changeLanguage }) => {
  const navigate = useNavigate();
  const [accountRedux, setAccount] = React.useState({
    accountUser: { msisdn: "" },
  });
  const { t } = useTranslation();

  const account = useSelector((state) => state.AccountReducer);
  const persist = useSelector((state) => state._persist);

  console.log("account: " + JSON.stringify(account));

  let welcome =
    isNotNull(account) &&
    isNotNull(account.accountUser) &&
    isNotNull(account.accountUser.msisdn)
      ? t("hello") + " " + accountRedux.accountUser.msisdn
      : "Hi there !";

  React.useEffect(() => {
    if (!persist?.rehydrated) {
      return;
    }

    if (
      !isNotNull(account) ||
      !isNotNull(account.accountUser) ||
      !isNotNull(account.accountUser.msisdn)
    ) {
      console.log("TO LOGIN");
      navigate("/flash", { replace: true });
    } else {
      console.log("msisdn: " + account.accountUser.msisdn);
    }

    setAccount(account);
  }, [persist.rehydrated, account]);

  function chooseLanguage(data) {
    changeLanguage(data);
  }

  return (
    <header>
      <div
        className="flex justify-around items-center"
        style={{ marginTop: "0px" }}
      >
        {/* <div
                    className="w-[50px] h-[33px] rounded-[12px] px-[4px] py-[8px] flex justify-center items-center bg-color-2 text-c-2 font-z-18" 
                    style={{
                        background : "transparent"
                    }}>
                </div> */}
        <div className="text-c-1" style={{ zIndex: "100", width: "100%" }}>
          {welcome}
        </div>
        <div className="relative">
          <a href="" className="title-main" style={{ fontSize: "30px" }}>
            {/* <img src={settingIcon} /> */}
            UWIN
          </a>
          {/* <div className="absolute top-0 right-[-10px] min-w-[250px] h-[225px] bg-linear-2 rounded-[20px] z-[9999] border-[1px] border-[#ffff] p-[15px] "
                        id="setting">
                        <div>
                            <div className="relative">
                                <div className="absolute right-0 top-0">
                                    <a href="#">
                                        <img src={settingIcon} />
                                    </a>
                                </div>
                                <img src={logo} />
                                <div className="absolute z-[1] w-full blend-mode top-[18%] left-[2%]">
                                    <img src={lightIcon} className="blink-effect w-[50%]" />
                                </div>
                                <div className="absolute z-[20] w-full blend-mode top-[45%] left-[20%]">
                                    <img src={lightIcon} className="blink-effect w-[40%]" />
                                </div>
                                <div className="absolute z-[20] w-full blend-mode top-[18%] left-[70%]">
                                    <img src={lightIcon} className="blink-effect w-[40%]" />
                                </div>
                            </div>
                            <div className="flex w-full justify-between mb-[10px]">
                                <div className="text-c-2" style={{ fontSize: '12px', }}>Game music</div>
                                <div className="flex items-center gap-2">
                                    <div className="on-btn">
                                        <div className="flex items-center gap-[2px]">
                                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M8.23333 12.05C8.01111 12.1389 7.80556 12.1111 7.61667 11.9667C7.42778 11.8222 7.33333 11.6222 7.33333 11.3667C7.33333 11.2444 7.36956 11.1362 7.442 11.042C7.514 10.9473 7.60556 10.8778 7.71667 10.8333C8.60556 10.4778 9.31956 9.91111 9.85867 9.13333C10.3973 8.35555 10.6667 7.47777 10.6667 6.49999C10.6667 5.52222 10.3973 4.64444 9.85867 3.86666C9.31956 3.08888 8.60556 2.52222 7.71667 2.16666C7.59444 2.12222 7.5 2.04999 7.43333 1.94999C7.36667 1.84999 7.33333 1.73888 7.33333 1.61666C7.33333 1.37222 7.42778 1.17777 7.61667 1.03333C7.80556 0.888883 8.01111 0.861105 8.23333 0.949994C9.36667 1.40555 10.2778 2.13333 10.9667 3.13333C11.6556 4.13333 12 5.25555 12 6.49999C12 7.74444 11.6556 8.86666 10.9667 9.86666C10.2778 10.8667 9.36667 11.5944 8.23333 12.05V12.05ZM0.666667 8.51666C0.477778 8.51666 0.319556 8.45266 0.192 8.32466C0.0640001 8.19711 0 8.03888 0 7.84999L0 5.18333C0 4.99444 0.0640001 4.83599 0.192 4.70799C0.319556 4.58044 0.477778 4.51666 0.666667 4.51666H2.66667L4.86667 2.31666C5.07778 2.10555 5.31933 2.05822 5.59133 2.17466C5.86378 2.29155 6 2.49999 6 2.79999V10.2333C6 10.5333 5.86378 10.7415 5.59133 10.858C5.31933 10.9749 5.07778 10.9278 4.86667 10.7167L2.66667 8.51666H0.666667ZM7.33333 9.18333V3.81666C7.83333 4.04999 8.236 4.41111 8.54133 4.89999C8.84711 5.38888 9 5.92777 9 6.51666C9 7.10555 8.84711 7.63888 8.54133 8.11666C8.236 8.59444 7.83333 8.94999 7.33333 9.18333ZM4.66667 4.41666L3.23333 5.84999H1.33333V7.18333H3.23333L4.66667 8.61666V4.41666Z"
                                                    fill="white" />
                                            </svg>
                                            <span className="text-c-1" style={{ fontSize: '12px', }}>On</span>
                                        </div>
                                    </div>
                                    <div className="off-btn">
                                        <div className="flex items-center gap-[2px]">
                                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M0.932745 0.503296L0 1.43604L2.88423 4.32027L2.69239 4.51873H0.0463065V8.48786H2.69239L6 11.7955V7.43604L8.76516 10.2012C8.33517 10.5253 7.85226 10.7833 7.32304 10.9355V12.2982C8.1965 12.0982 9.01309 11.7024 9.71114 11.1406L11.0673 12.4967L12 11.5639L0.932745 0.503296ZM4.67696 8.60032L3.24146 7.16482H1.36935V5.84177H3.24146L3.82359 5.25964L4.67696 6.113V8.60032ZM10.6307 6.5033C10.6307 7.04574 10.5314 7.56835 10.3594 8.05126L11.3716 9.06338C11.742 8.2894 11.9537 7.42281 11.9537 6.5033C11.9537 3.67198 9.97574 1.30374 7.32304 0.701752V2.06449C9.23484 2.6334 10.6307 4.40627 10.6307 6.5033ZM6 1.21112L4.75634 2.45478L6 3.69844V1.21112ZM8.97685 6.5033C8.97671 5.94902 8.82182 5.40579 8.52964 4.93479C8.23745 4.46378 7.81956 4.08371 7.32304 3.83736V5.02149L8.96362 6.66206C8.97023 6.60914 8.97685 6.55622 8.97685 6.5033Z"
                                                    fill="white" />
                                            </svg>
                                            <span className="text-c-1" style={{ fontSize: '12px', }}>Off</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex w-full justify-between mb-[10px]">
                                <div className="text-c-2" style={{ fontSize: '12px', }}>Language</div>
                                <div className="flex gap-2 items-center">
                                    <div onClick={() => chooseLanguage('la')}>
                                        <img src={laIcon} />
                                    </div>
                                    <div onClick={() => chooseLanguage('en')}>
                                        <img src={enIcon} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full justify-between mb-[10px]">
                            <div className="text-c-2" style={{ fontSize: '12px', }}>Cancel service</div>
                            <div className="w-[96px] h-[23px] bg-[#FF76AC] rounded-[12px] flex justify-center items-center">
                                <span className="text-[#FFFFFF] font-[600] text-[12px] font-['Quicksand']">Cancel</span>
                            </div>
                        </div>
                    </div> */}
        </div>
      </div>
    </header>
  );
};

export default Header;
